module.exports = __webpack_public_path__ + "static/media/drop_in_events.0ab1cd56.png";